import { paginationQuestion } from '../../reducers/Pagination/pagination.reducer';
import { paginationStore } from '../../rootReducer';

export function selectPaginationQuestion(state) {
    return state[paginationStore][paginationQuestion];
}
